import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { getRouting, formDataGenerator } from '../../../../utils/common';
import './style.scss';
import { knowledgeStackSubscription } from './actions';   

const SubscribeKnowledgeStack = (props) => {

    const { knowledgeStackSubscription, subscriptionData, type, article} = props;
    const [successMassage, setSuccessMassage] = useState(0);
    const [email, setEmail] = useState();
    const validationSchema = Yup.object().shape({
        email: Yup.string().email('Email is not correct').required('Please Enter your address details'),
    });
    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema,
        // validateOnChange: false,
        // validateOnBlur: false,
        onSubmit: (data) => {
            let payload = {
                email: data.email,
                type: type,
                article: article,
            }
            knowledgeStackSubscription(formDataGenerator(payload));
        },
    });

    useEffect(() => {
        if (formik.values.email) {
            setEmail(formik.values.email);
        }
    }, [formik.values.email])

    useEffect(() => {
        if (subscriptionData && subscriptionData.message) {
            setSuccessMassage(1);
            formik.resetForm()
            setTimeout(() => {
                setSuccessMassage(0);
            }, 30000);
        }
    }, [subscriptionData])


    return (
        <div>
            {successMassage === 0 ?
                <form onSubmit={formik.handleSubmit}>
                    <div className='bg-warning mt-5 mb-5'>
                        <div className='row px-3 py-5'>
                            <div className="col-md-9 mx-auto">
                                <div>
                                    <div className="row justify-content-center">
                                        <div className="col-lg-9">
                                        {/* <h3 className='text-center mb-3'>Did you find this interesting</h3> */}
                                            <p className='text-center mb-3'>Subscribe to our exclusive newsletter to get our latest updates</p>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-md-8 mb-3">
                                            <input type="text" placeholder="Email Address" name='email' onChange={formik.handleChange} value={formik.values.email} className={'invalid form-control' + (formik.errors.email && formik.touched.email ? ' is-invalid' : '')} autoComplete='off' aria-autocomplete="none" />
                                            <div className="invalid-feedback">
                                                {formik.errors.email && formik.touched.email ? formik.errors.email : null}
                                            </div>
                                        </div>
                                        <div className="col-md-4 mb-3">
                                            <button className='w-100 btn btn-primary' type="submit">Subscribe</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form> :
                <div className='bg-warning mt-5 mb-5'>
                    <div className='row px-3 py-5 thanks'>
                        <div className="col-md-6 mx-auto">
                            <div>
                                <h3 className='text-center mb-3'>Did you find this interesting</h3>
                                <p className='text-center mb-3'>Subscribe to get latest updates</p>
                                <button className='w-100 btn btn-light' type="button">Thanks For Signing Up</button>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

const mapStateToProps = (state) => ({
    subscriptionData: state.KnowledgeStack.knowledgeSubscription,
});

const mapDispatchToProps = (dispatch) => ({
    knowledgeStackSubscription: bindActionCreators(knowledgeStackSubscription, dispatch),
});


export default connect(mapStateToProps, mapDispatchToProps)(SubscribeKnowledgeStack);